import { Component, HostBinding, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DisplayedColumns } from '../ed-table/ed-table.component';

@Component({
    selector: 'table-card',
    templateUrl: './table-card.component.html',
    styleUrls: ['./table-card.component.scss'],
})
export class TableCardComponent {
    @Input() title: string | undefined;
    @Input() descriptionTitle?: string;
    @Input() descriptionContent?: string;
    @Input() dataSource!: MatTableDataSource<any>;
    @Input() displayedColumns: DisplayedColumns[] = [];
    @Input() error: boolean = false;
    @Input() isLoading: boolean = true;
    @Input() cardClass: string = '';

    // Bind the cardClass property to the class attribute of the host element
    @HostBinding('class') get hostClasses(): string {
        return this.cardClass;
    }

    constructor() {}
}
